import { TranslationKeys } from './translationKeys';

export const reportStateStatuses = {
  lose: 0,
  win: 1,
  pending: 2,
  canceled: 3,
  unknown: 4,
  calculation: 5,
  onCancel: 6,
  onHold: 7,
};

export const ValidationType = {
  InvalidToken: 0,
  InvalidSpin: 1,
  MoneyTransactionError: 2,
  NotEnoughMoney: 3,
  InvalidOperation: 4,
  SpinNotFound: 5,
  InvalidSpinCount: 6,
  InvalidAmount: 7,
  BuyBonusDisabled: 8,
  PartnerNotFound: 9,
  Success: 10,
  BonusNotFound: 11,
  InvalidSpinResult: 12,
  BonusAlreadyExists: 13,
  PlayerLimitExceeded: 14,
  InvalidRange: 15,
  InvalidIndex: 16,
  InvalidData: 17,
  InvalidSpinData: 18,
  MaintenanceNotify: 20,
  FreeBetError: 21,
  MaxBetLimit: 22,
  InsufficientBalance: 23,
};

export const ResponseTypeForGamesByRound = {
  Success: 'Success',
  GeneralError: 'GeneralError',
  InValidMinBet: 'InValidMinBet',
  InValidMaxBet: 'InValidMaxBet',
  InvalidBet: 'InvalidBet',
  InsufficientBalance: 'InsufficientBalance',
  MoneyTransactionError: 'MoneyTransactionError',
  UnAuthorizedUser: 'UnAuthorizedUser',
  InvalidBetTime: 'InvalidBetTime',
  InvalidRoundId: 'InvalidRoundId',
  InValidBetData: 'InValidBetData',
  InValidToken: 'InValidToken',
  FreeBetError: 'FreeBetError',
  ResultNotFound: 'ResultNotFound',
  BetsCountExceeded: 'BetsCountExceeded',
  InvalidFreeBetData: 'InvalidFreeBetData',
  InvalidFreeBetMaxOdd: 'InvalidFreeBetMaxOdd',
  InvalidFreeBetMinOdd: 'InvalidFreeBetMinOdd',
  LimitsNotFound: 'LimitsNotFound',
  PartnerGameConfigNotFound: 'PartnerGameConfigNotFound',
  PlayerLimitExceeded: 'PlayerLimitExceeded',
  InValidAutoCashOutOdd: 'InValidAutoCashOutOdd',
  NotEnoughBalance: 'NotEnoughBalance',
  NotEnoughMoney: 'NOT_ENOUGH_MONEY',
  MaxBetLimit: 'MaxBetLimit',
  MaintenanceNotify: 'MaintenanceNotify',
};

export const ValidationResponseCodeForGameByRound = {
  [ResponseTypeForGamesByRound.Success]: 0,
  [ResponseTypeForGamesByRound.GeneralError]: 1,
  [ResponseTypeForGamesByRound.InValidMinBet]: 2,
  [ResponseTypeForGamesByRound.InValidMaxBet]: 3,
  [ResponseTypeForGamesByRound.InvalidBet]: 4,
  [ResponseTypeForGamesByRound.NotEnoughBalance]: 5,
  [ResponseTypeForGamesByRound.MoneyTransactionError]: 6,
  [ResponseTypeForGamesByRound.UnAuthorizedUser]: 7,
  [ResponseTypeForGamesByRound.InvalidBetTime]: 8,
  [ResponseTypeForGamesByRound.InvalidRoundId]: 9,
  [ResponseTypeForGamesByRound.InValidBetData]: 10,
  [ResponseTypeForGamesByRound.InValidToken]: 11,
  [ResponseTypeForGamesByRound.FreeBetError]: 12,
  [ResponseTypeForGamesByRound.ResultNotFound]: 13,
  [ResponseTypeForGamesByRound.BetsCountExceeded]: 14,
  [ResponseTypeForGamesByRound.InvalidFreeBetData]: 15,
  [ResponseTypeForGamesByRound.InvalidFreeBetMaxOdd]: 16,
  [ResponseTypeForGamesByRound.InvalidFreeBetMinOdd]: 17,
  [ResponseTypeForGamesByRound.LimitsNotFound]: 18,
  [ResponseTypeForGamesByRound.PartnerGameConfigNotFound]: 19,
  [ResponseTypeForGamesByRound.PlayerLimitExceeded]: 20,
  [ResponseTypeForGamesByRound.InValidAutoCashOutOdd]: 21,
  [ResponseTypeForGamesByRound.MaxBetLimit]: 22,
  [ResponseTypeForGamesByRound.InsufficientBalance]: 23,
  [ResponseTypeForGamesByRound.MaintenanceNotify]: 24,
};

export const ValidationTypeForGamesByRound = {
  0: [ResponseTypeForGamesByRound.Success],
  1: [ResponseTypeForGamesByRound.GeneralError],
  2: [ResponseTypeForGamesByRound.InValidMinBet],
  3: [ResponseTypeForGamesByRound.InValidMaxBet],
  4: [ResponseTypeForGamesByRound.InvalidBet],
  5: [ResponseTypeForGamesByRound.NotEnoughMoney],
  6: [ResponseTypeForGamesByRound.MoneyTransactionError],
  7: [ResponseTypeForGamesByRound.UnAuthorizedUser],
  8: [ResponseTypeForGamesByRound.InvalidBetTime],
  9: [ResponseTypeForGamesByRound.InvalidRoundId],
  10: [ResponseTypeForGamesByRound.InValidBetData],
  11: [ResponseTypeForGamesByRound.InValidToken],
  12: [ResponseTypeForGamesByRound.FreeBetError],
  13: [ResponseTypeForGamesByRound.ResultNotFound],
  14: [ResponseTypeForGamesByRound.BetsCountExceeded],
  15: [ResponseTypeForGamesByRound.InvalidFreeBetData],
  16: [ResponseTypeForGamesByRound.InvalidFreeBetMaxOdd],
  17: [ResponseTypeForGamesByRound.InvalidFreeBetMinOdd],
  18: [ResponseTypeForGamesByRound.LimitsNotFound],
  19: [ResponseTypeForGamesByRound.PartnerGameConfigNotFound],
  20: [ResponseTypeForGamesByRound.PlayerLimitExceeded],
  21: [ResponseTypeForGamesByRound.InValidAutoCashOutOdd],
  22: [ResponseTypeForGamesByRound.MaxBetLimit],
  23: [ResponseTypeForGamesByRound.InsufficientBalance],
  24: [ResponseTypeForGamesByRound.MaintenanceNotify],
};

export const ErrorMessagesForGamesByRound = {
  [ResponseTypeForGamesByRound.Success]: TranslationKeys.BetIsAccepted,
  [ResponseTypeForGamesByRound.GeneralError]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.InValidMinBet]: TranslationKeys.MinimumBet,
  [ResponseTypeForGamesByRound.InValidMaxBet]: TranslationKeys.MaximumBet,
  [ResponseTypeForGamesByRound.InvalidBet]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.InsufficientBalance]: TranslationKeys.InsufficientBalance,
  [ResponseTypeForGamesByRound.NotEnoughMoney]: TranslationKeys.NotEnoughMoney,
  [ResponseTypeForGamesByRound.MoneyTransactionError]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.UnAuthorizedUser]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.InvalidRoundId]: TranslationKeys.BetNotAccepted,
  [ResponseTypeForGamesByRound.InvalidBetTime]: TranslationKeys.BetNotAccepted,
  [ResponseTypeForGamesByRound.InValidBetData]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.FreeBetError]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.ResultNotFound]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.BetsCountExceeded]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.InvalidFreeBetData]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.InvalidFreeBetMaxOdd]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.InvalidFreeBetMinOdd]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.LimitsNotFound]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.PartnerGameConfigNotFound]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.PlayerLimitExceeded]: TranslationKeys.PlayerLimitExceeded,
  [ResponseTypeForGamesByRound.InValidAutoCashOutOdd]: TranslationKeys.InValidAutoCashOutOdd,
  [ResponseTypeForGamesByRound.MaxBetLimit]: TranslationKeys.BetCanceled,
  [ResponseTypeForGamesByRound.MaintenanceNotify]: TranslationKeys.MaintenanceNotify,
};
